import { theme } from 'pfm-ui-components';
import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const GlobalStyle = createGlobalStyle`
  
  ${normalize}
  
  *:not(svg) {
    box-sizing: border-box;
  }
  
  svg {
    box-sizing: content-box;
  }  

  a {
    text-decoration: none;
  }
  
  html {
    line-height: 1;
    font-family: ${theme.fonts.fontFamily};
    font-size: ${theme.fonts.baseFontSize}px;
  } 
   
  body {
    background-color: #f6f7f8;
    color: #4a4a4a;
    position:relative;
    height:100%;
  }
  
  ::-webkit-scrollbar {
    height: 0.5rem !important;
    width: 7px !important;
    visibility: hidden;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color:  rgba(0, 0, 0, 0.5) !important;
    height: 66px;
    opacity: 0.1;
    border-radius: 10px;
  }
`;

export default GlobalStyle;
